<div class="adm-page__header">
  @if (showBack()) {
    <button type="button" class="adm-page__back" (click)="back.emit()">
      <i class="bx bx-arrow-back" aria-hidden="true"></i>
      <span>{{ backLabel() }}</span>
    </button>
  }
  <div class="adm-page__titles">
    @if (eyebrow(); as kicker) {
      <span class="eyebrow adm-page__eyebrow">{{ kicker }}</span>
    }
    <h1 class="adm-page__title">{{ title() }}</h1>
  </div>
  <div class="adm-page__actions">
    <ng-content select="[page-actions]" />
  </div>
</div>
